/*
  ============================================================================
  bb-tm-crosssell.js — "completa il lavoro", guidato dalla compatibilita'
  ----------------------------------------------------------------------------
  Owner:  Linea Group per BlackBoost USA
  Perche: la sezione related-products di Dawn oggi rende ZERO card su tutte le
          132 schede (verificato su 14 prodotti a caso). Lo slot naturale di
          cross-sell su un catalogo da $1.227 di ticket mediano e' vuoto.

  COSA FA
  Prende le piattaforme del prodotto corrente da bb-fitment.json, cerca gli
  altri prodotti che stanno sulle STESSE piattaforme, scarta quelli della
  stessa categoria (un downpipe non si vende accanto a un altro downpipe) e
  mostra al massimo quattro pezzi che completano il lavoro sulla stessa auto.

  COSA NON FA
  Non dice mai che un pezzo "monta". Il verdetto e' solo di bb-fit-verdict, e
  il dataset e' ancora non verificato. Qui si dice "stessa piattaforma", che e'
  un fatto del catalogo, non una promessa tecnica.

  SENZA JS
  La sezione non si stampa affatto. Non nasconde e non rimpiazza contenuto
  server-side: e' additiva.
  ============================================================================
*/
(function () {
  'use strict';


  /*
    Il dataset con le correzioni gia' applicate.

    bb-fitment-overrides.json e' il file che si modifica a mano dall'admin di
    Shopify per correggere una compatibilita'. Le correzioni le applica
    bb-garage.js quando carica: se questo script si rifacesse la fetch per conto
    suo leggerebbe la base senza correzioni, e la stessa auto risulterebbe
    compatibile qui e non compatibile sulla scheda prodotto. Quindi si chiede il
    dato gia' pronto al garage, e si scarica da soli solo se il garage non c'e'.
  */
  function datasetFitment(url) {
    var G = window.BBGarage;
    if (G && G.ready) {
      return G.ready().then(function () { return G.data; }).catch(function () {
        return fetch(url, { credentials: 'omit' }).then(function (r) { return r.json(); });
      });
    }
    return fetch(url, { credentials: 'omit' }).then(function (r) { return r.json(); });
  }


  var root = document.querySelector('[data-bb-crosssell]');
  if (!root) return;

  var handle = root.getAttribute('data-handle') || '';
  var money = root.getAttribute('data-money') || '${{amount}}';
  var fitUrl = root.getAttribute('data-fitment-url');
  var catUrl = root.getAttribute('data-catalog-url');
  if (!handle || !fitUrl || !catUrl) return;

  var MAX = 4;

  /*
    IL PREZZO LO DA' SHOPIFY, NON UN CONTO NOSTRO (1 ott 2026).
    Prima si prendeva il prezzo in dollari di bb-catalog.json e lo si
    moltiplicava per Shopify.currency.rate. Shopify Markets pero' arrotonda i
    prezzi convertiti e la moltiplicazione no: per un cliente negli Emirati la
    card diceva "Dhs. 22,362.10" e la scheda dello stesso pezzo "Dhs. 22,363.00
    AED". Ora ogni card chiede /products/<handle>.js, che risponde gia' nella
    valuta del cliente e con lo stesso arrotondamento della scheda (in
    centesimi). Il prezzo del catalogo serve ancora solo per ordinare i
    consigli, e per i clienti in dollari se la richiesta fallisce.
    Il codice valuta (USD, AED) si aggiunge solo se il prezzo della scheda lo
    mostra (impostazione currency_code_enabled di Dawn): card e scheda si
    leggono uguali.
  */
  var valuta = '', tasso = 1;
  try {
    valuta = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    tasso = parseFloat(Shopify.currency.rate) || 1;
  } catch (e) { tasso = 1; }

  function conCodice() {
    var p = document.querySelector('.product__info-container .price-item');
    return !!(valuta && p && new RegExp('\\b' + valuta + '\\s*$').test(p.textContent.trim()));
  }

  // centesimi -> testo, con i formati di Shopify (1,234.56 / 1.234,56 / 1'234.56 ...)
  function fmt(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return '';
    function num(dec, mil, sep) {
      var s = (n / 100).toFixed(dec).split('.');
      return s[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + mil) + (s[1] ? sep + s[1] : '');
    }
    var out = money.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return num(0, ',', '.');
        case 'amount_with_comma_separator': return num(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return num(0, ' ', '');
        case 'amount_with_space_separator': return num(2, ' ', ',');
        case 'amount_with_period_and_space_separator': return num(2, ' ', '.');
        default: return num(2, ',', '.');
      }
    });
    return conCodice() ? out + ' ' + valuta : out;
  }

  var prezzi = {};
  function prezzoVero(h, usd) {
    if (!prezzi[h]) {
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      prezzi[h] = fetch(base + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (p) { return p.price; })
        .catch(function () {
          delete prezzi[h];                                   // si riprova al prossimo disegno
          return valuta === 'USD' && tasso === 1 && usd ? Math.round(usd * 100) : null;
        });
    }
    return prezzi[h];
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  Promise.all([
    datasetFitment(fitUrl),
    fetch(catUrl, { credentials: 'omit' }).then(function (r) { return r.json(); })
  ]).then(function (res) {
    // Si ridisegna quando il cliente cambia auto: adesso l'elenco DIPENDE
    // dall'auto scelta, quindi lasciarlo fermo mostrerebbe i consigli della
    // macchina precedente.
    var Gg = window.BBGarage;
    if (Gg && Gg.subscribe) {
      Gg.subscribe(function () { try { disegna(res); } catch (e) {} });
      return;
    }
    disegna(res);
  }).catch(function () { /* silenzio: la sezione resta nascosta */ });

  function disegna(res) {
    var fit = res[0], cat = res[1].products || {};
    var byHandle = fit.products || {};
    var mine = byHandle[handle];
    if (!mine || !mine.length) { root.hidden = true; return; }

    var myType = (cat[handle] && cat[handle].y) || '';
    var mySet = {};
    mine.forEach(function (id) { mySet[id] = true; });

    /*
      SE IL CLIENTE HA DETTO CHE AUTO HA, SI CONSIGLIA SOLO CIO' CHE VA SU QUELLA.

      Prima il punteggio guardava le piattaforme in comune col PRODOTTO della
      pagina, non con l'auto del cliente. Un pezzo che condivide una sola
      piattaforma su venti finiva consigliato lo stesso. Misurato sul dataset:
      il 41% delle coppie (auto scelta, consiglio) proponeva un pezzo che su
      quell'auto NON va. Il caso peggiore: chi ha una M2 (G87), sulla pagina
      dell'aspirazione, si vedeva consigliare i downpipe della M4/M3 (G82/G83).

      Con l'auto scelta il filtro diventa netto: entra solo cio' che e' elencato
      per quell'auto. Senza auto scelta resta il criterio di prima, che non
      promette niente a nessuno in particolare.
    */
    var G = window.BBGarage;
    var mioVeicolo = (G && G.get && G.get()) || null;
    var suMiaAuto = null;
    if (mioVeicolo && G.productsFor) {
      suMiaAuto = {};
      (G.productsFor(mioVeicolo.id) || []).forEach(function (h) { suMiaAuto[h] = true; });
    }

    // punteggio: quante piattaforme in comune. Piu' condivisione, piu' e' pertinente.
    var scored = [];
    Object.keys(byHandle).forEach(function (h) {
      if (h === handle) return;
      var info = cat[h];
      if (!info || info.a === undefined ? false : !info.a) return;   // fuori catalogo
      if (!info) return;
      if (suMiaAuto && !suMiaAuto[h]) return;                        // non va sulla sua auto
      var type = info.y || '';
      if (type && myType && type === myType) return;                 // stessa categoria: no
      var shared = 0;
      byHandle[h].forEach(function (id) { if (mySet[id]) shared++; });
      if (!shared) return;
      scored.push({ h: h, info: info, shared: shared });
    });

    if (!scored.length) { root.hidden = true; return; }

    scored.sort(function (a, b) {
      if (b.shared !== a.shared) return b.shared - a.shared;
      return (b.info.p || 0) - (a.info.p || 0);
    });

    // una sola voce per categoria: quattro downpipe diversi non aiutano nessuno
    var seenType = {}, picks = [];
    scored.forEach(function (x) {
      if (picks.length >= MAX) return;
      var t = x.info.y || '_';
      if (seenType[t]) return;
      seenType[t] = true;
      picks.push(x);
    });
    for (var i = 0; picks.length < MAX && i < scored.length; i++) {
      if (picks.indexOf(scored[i]) === -1) picks.push(scored[i]);
    }

    /*
      SEMPRE 4 O 2, MAI 3: la griglia e' a 2 colonne da telefono e a 4 da
      desktop, con 3 pezzi restava una casella vuota (Sebastiano, 1 ott 2026:
      "fagli vedere quattro prodotti, sempre, oppure due"). Con un solo pezzo
      si mostra la card da sola: il CSS stringe la griglia, niente caselle vuote.
    */
    var n = picks.length >= 4 ? 4 : (picks.length >= 2 ? 2 : picks.length);
    picks = picks.slice(0, n);
    root.querySelector('[data-bb-crosssell-list]').setAttribute('data-count', String(n));

    var html = picks.map(function (x) {
      var d = x.info;
      var img = d.i
        ? '<img src="' + esc(d.i) + '" alt="" loading="lazy" width="400" height="400">'
        : '<span class="bb-tm-xs__noimg" aria-hidden="true"></span>';
      // il numero arriva da prezzoVero() qui sotto, appena Shopify risponde
      var price = d.p ? '<span class="bb-tm-xs__price" data-bb-xs-price="' + esc(x.h) + '"></span>' : '';
      var type = d.y ? '<span class="bb-tm-xs__type">' + esc(d.y) + '</span>' : '';
      return '<li class="bb-tm-xs__cell">' +
        '<a class="bb-tm-xs__card" href="/products/' + esc(x.h) + '">' +
          '<span class="bb-tm-xs__media">' + img + '</span>' +
          type +
          '<span class="bb-tm-xs__title">' + esc(d.t) + '</span>' +
          price +
        '</a></li>';
    }).join('');

    root.querySelector('[data-bb-crosssell-list]').innerHTML = html;
    root.hidden = false;

    picks.forEach(function (x) {
      if (!x.info.p) return;
      prezzoVero(x.h, x.info.p).then(function (cents) {
        var el = root.querySelector('[data-bb-xs-price="' + x.h.replace(/"/g, '') + '"]');
        if (el && cents != null) el.textContent = fmt(cents);
      });
    });
  }
})();
